export default __webpack_public_path__ + "static/media/XS4 Mini Ansi.7546023d.jpg";